import { Component, OnInit } from '@angular/core';
import { BackgroundPhotoService, defaultBackgroundUrl } from '../services/background-photo.service';

/** @title Sidenav open & close behavior */
@Component({
  selector: 'app-landing-page',
  templateUrl: 'landing-page.html',
  styleUrls: ['landing-page.scss'],
})
export class LandingPageComponent implements OnInit {

  backgroundUrls: string[] = [];
  selectedBackground: string;
  events: string[] = [];
  opened = true;
  shouldRun = true;

  constructor(private backgroundPhotoService: BackgroundPhotoService) {}

  ngOnInit() {
    this.loadBackgroundPhotos();
  }

  private loadBackgroundPhotos() {
    this.backgroundPhotoService.getRandomBackgroundUrl().subscribe({
      next: (backgroundUrl) => {
        this.selectedBackground = backgroundUrl;
      },
      error: () => {
        // Fallback to default background
        this.selectedBackground = `url("${defaultBackgroundUrl}") no-repeat center center fixed`;
      }
    });
  }
}
